/**
 * Orden de visualización al publicar (idx sigue alineado con checkout y columnas `listings`).
 * 1 Entrega física · 2 Envío directo · 3 Punto de recogida · 4 Partner verificador
 */
export const LISTING_SHIPPING_OPTIONS = [
  { idx: 3, key: 'physical', label: 'Entrega física', desc: 'Quedada directa con el comprador' },
  { idx: 0, key: 'direct', label: 'Envío directo', desc: 'Tú gestionas el envío' },
  { idx: 1, key: 'pickup', label: 'Punto de recogida', desc: 'El comprador recoge en punto neutral' },
  { idx: 2, key: 'verified', label: 'Partner verificador', desc: 'Un partner verifica y gestiona la entrega' },
];

export function shippingIndicesFromRow(row) {
  if (!row) return [3];
  const idxs = [];
  if (row.ships_direct ?? row.shipsDirect) idxs.push(0);
  if (row.ships_pickup ?? row.shipsPickup) idxs.push(1);
  if (row.ships_verified ?? row.shipsVerified) idxs.push(2);
  if (row.ships_physical ?? row.shipsPhysical) idxs.push(3);
  return idxs.length ? idxs : [3];
}

export function shippingFlagsFromIndices(indices) {
  const set = new Set(Array.isArray(indices) ? indices : []);
  return {
    ships_direct: set.has(0),
    ships_pickup: set.has(1),
    ships_verified: set.has(2),
    ships_physical: set.has(3),
  };
}

export function shippingIndicesFromFlags(row) {
  return shippingIndicesFromRow(row);
}
